import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {MenuItemDef, ProcessCellForExportParams} from 'ag-grid-enterprise';
import {IrbCustomHeaderComponent} from './irb-custom-header.component';
import {PortColFormatterComponent} from './portcolformatter.component';
import {IrbAgNumberColumnFilterComponent} from './irb-ag-number-column-filter/irb-ag-number-column-filter.component';
import {IrbAgSearchMultipleColumnFilterComponent} from './irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';
import {CustomOverlayComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/custom-overlay/custom-overlay.component';
import {DropdownFilterEditorComponent} from '@irb-common/components/grid/editors/dropdownFilter-editor.component';
import {IrbAgSetColumnFilterComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component';
import {IrbAgDateColumnFilterComponent} from './irb-ag-date-column-filter/irb-ag-date-column-filter.component';
import {IrbDefaultHeaderComponent} from './irb-default-header.component';
import {ModelReadCellComponent} from '../grid/renderers/model-read-cell.component';
import {ColorCategoryComponent} from '@irb-common/components/grid/renderers/color-category/color-category.component';
import {NumericEditorComponent} from '@irb-common/components/grid/editors/numeric-editor.component';
import {IrbHeaderGroupComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/header-group/header-group.component';
import {DatePipe} from '@angular/common';
import {EasternTimePipe} from '@irb-common/pipes/EasternTimePipe';
import {IrbAgSingleSelectColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-single-select-column-filter/irb-ag-single-select-column-filter.component";
import {CustomNoRowOverlayComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/custom-norow-overlay/custom-norow-overlay.component';
import { IrbInputFloatingFilterComponent } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-input-floating-filter/irb-input-floating-filter.component';
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb/app.events';
import { provideGlobalGridOptions } from 'ag-grid-community';
provideGlobalGridOptions({
    theme: "legacy",
});

@Component({ standalone: false,
    selector: 'irb-inventory-grid',
    template: `
        @if (showFiltersColumns) {
            <div style="display: flex;justify-content: flex-end;" class="grid-filters-columns-buttons">
                @if (filterToolPanelExists) {
                    <a (click)="showGridFiltersToolBar()"><img src="../../assets/images/filters.svg">Filters</a>
                }
                <a (click)="showGridColumnsToolBar()"><img src="../../assets/images/columns.svg">Columns</a>
            </div>
        }
    <ag-grid-angular
      #agGrid
      [style.width] = "'100%'"
      [style.height] = "gridHeight"
      id="irbInventoryGrid"
      class="ag-theme-balham irbInventoryGrid"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData"
      [sideBar]="sideBar"
      [components]="frameworkComponents"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      (rowClicked)="onRowClicked($event)"
      (toolPanelVisibleChanged)="sizeColumnstoFitCall($event)"
      (displayedColumnsChanged)="saveStateForUser()"
      (sortChanged)="onSortChanged($event)"
      (filterChanged)="hidePopupApplyFilter()"
      (displayedColumnsWidthChanged) ="displayedColumnstoFitCall($event)"
      [icons]="icons"
      [stopEditingWhenCellsLoseFocus]="true"
      [masterDetail]="masterDetail"
      [detailCellRendererParams]="detailCellRendererParams"
      [loadingOverlayComponent]="loadingOverlayComponent"
      [loadingOverlayComponentParams]="loadingOverlayComponentParams"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
      [isExternalFilterPresent]="gridOptions.isExternalFilterPresent"
      [doesExternalFilterPass]="gridOptions.doesExternalFilterPass"
      [localeText]="localeText"
      [getContextMenuItems]="getContextMenuItems.bind(this)"
      [headerHeight]="headerHeight"
      [popupParent]="popupParent"
      [domLayout]="domLayout"
      (cellEditingStarted)="gridOptions.onCellEditingStarted || null"
      (cellEditingStopped)="gridOptions.onCellEditingStopped || null"
      (columnVisible)="onColumnVisible($event)"
      (columnResized)="onColumnResized($event)"
      (rowSelected)="onRowSelected($event)"
      (modelUpdated)="restoreSelection(); onColumnVisible(null);"
    ></ag-grid-angular>
    @if (footerContent) {
      <div class="gridFooter" [innerHTML]="footerContent | decodeHtml"></div>
    }
    `,
    styleUrls: ['./irebal-ag-grid-ent-avatar.component.scss']
})
export class IrebalAgGridEntAvatarComponent implements OnInit {
    @Input() gridOptions: any;
    public gridApi: any;
    private gridColumnApi: any;
    @Input() columnDefs: any;
    @Input() autoColumnId: string;
    @Output() gridReady = new EventEmitter<boolean>();
    @Output() cellValueChanged = new EventEmitter<boolean>();
    @Output() rowClicked = new EventEmitter<boolean>();
    @Output() onResetSavedState = new EventEmitter<any>();
    @Output() columnVisible = new EventEmitter<any>();
    defaultColDef: any;
    private floatingFiltersHeight: any;
    private pivotGroupHeaderHeight: any;
    private pivotHeaderHeight: any;
    @Input() rowData: any;
    @Input() showSideBar: boolean = true;
    @Input() sideBar: any;
    disableActionBtn = true;
    //selectedTaxability: any;
    //selectedPriorityNote: any;
    // by default, material uses 8px as a base unit for its grid. The logic below overrides that
    gridSize = 6;
    rowHeight = this.gridSize * 5;
    @Input() headerHeight = this.gridSize * 5;
    groupHeaderHeight = this.gridSize * 5;
    @Input() frameworkComponents: any;
    icons: any;
    @Input() footerContent: any;
    @Input() masterDetail: boolean;
    @Input() detailCellRendererParams: any;
    @Input() loadingOverlayComponent: any;
    @Input() loadingOverlayComponentParams: any;
    @Input() noRowsOverlayComponent: any;
    @Input() noRowsOverlayComponentParams: any;
    @Input() componentName: any;
    @Input() gridHeight = '100%';
    @Input() contextMenuItems: Array<MenuItemDef> = [];
    @Input() popupParent:any;
    @Input() domLayout: any ='normal';
    @Input() suppressRowClickSelection = true;
    @Input() rowSelection = 'multiple';
    @Input() saveSortState = true;
    @Input() showFiltersColumns = false;
    private isGridLoaded: boolean = false;
    private defaultColumnStateOnPageLoad: any;
    localeText = {
        applyFilter: 'Apply',
        resetFilter: 'Clear',
        clearFilter: 'Clear',
        cancelFilter: 'Cancel'
    };

    //modules: Module[] = AllModules;
    savedState: any;
    colState: any;
    sortState: any;
    screenResolutionState: any;
    filterParams: any;
    minifilters: Map<string, string> = new Map<string, string>();
    private isUiUnitTest = false;
    selectedIds: any = [];
    deSelectedIds: any = [];
    filterToolPanelExists: boolean = false;
    @Input() columnLimits: any;

    constructor(private eRef: ElementRef, private dp: DatePipe, private etp: EasternTimePipe, private as: AppService) {
        this.defaultColDef = {
            sortable: true,
            resizable: true,
            filter: false,
            menuTabs: [],
            minWidth: 48,
            suppressKeyboardEvent: (params: any) => { return params.event.code === 'Space' }
        };
        this.isUiUnitTest = (window as any).unittestrunningflag;
    }

    ngOnInit() {
        this.getSavedState();
        this.updateGridDefault();
        if (this.gridOptions && this.gridOptions.columnDefs) {
            this.defaultColDef.floatingFilter = this.gridOptions.floatingFilter;
            delete this.gridOptions.floatingFilter;
            this.gridOptions.columnDefs.forEach((col: any) => {
                if (col.children) { // 2nd level of column headers. If there are more, then should do a "tree traversal"
                    col.children.forEach((child: any) => {
                        if (child.filter === 'agSetColumnFilter') {
                            if (!child.filterParams) {
                                child.filterParams = {};
                            }
                            if (child.filterParams.defaultToNothingSelected === undefined) {
                                child.filterParams.defaultToNothingSelected = true;
                            }
                        }
                    });
                } else if (col.filter === 'agSetColumnFilter') {
                    if (!col.filterParams) {
                        col.filterParams = {};
                    }
                    if (col.filterParams.defaultToNothingSelected === undefined) {
                        col.filterParams.defaultToNothingSelected = true;
                    }
                }
            });
        }
    }

    onGridReady(params: any) {
        this.gridApi = params.api;
        this.gridColumnApi = params.api;
        this.gridReady.emit(params);
        this.isGridLoaded = true;
        this.defaultColumnStateOnPageLoad = { 
            'gridColumnApi': this.gridColumnApi, 
            'getColumnGroupState': this.gridColumnApi.getColumnGroupState(), 
            'getColumnState': this.gridColumnApi.getColumnState() 
        };
        this.applyToolbarColumnResetButton();

        if (!this.isUiUnitTest) {
            setTimeout(() => {
                this.resetSavedState(params);
                this.resetSavedColumnSize(params);
            });
        }
    }

    getGridApi() {
        return this.gridApi;
    }

    @HostListener('document:click', ['$event'])
    clickOutsideGrid($event: any): void {
        const agHeader = document.getElementsByClassName('ag-header')[0];
        const agSidebar = document.getElementsByClassName('ag-side-bar')[0];
        const gridFooter = document.getElementsByClassName('gridFooter')[0];
        if (
            !this.eRef.nativeElement.contains($event.target) ||
            (agHeader && agHeader.contains($event.target)) ||
            (agSidebar && agSidebar.contains($event.target)) ||
            (gridFooter && gridFooter.contains($event.target)) ||
            $event.target.parentElement.classList.contains('ag-selection-checkbox')
          ) {
            this.gridApi && this.gridApi.clearRangeSelection();
          }
    }

    onCellValueChanged(params: any) {
        this.cellValueChanged.emit(params);
    }

    onRowClicked(params: any) {
        this.rowClicked.emit(params);
    }

    onSortChanged(_event: any) {
        this.gridApi.deselectAll();
        this.saveStateForUser();
    }

    updateGridDefault() {
        this.setIcons();
        this.gridOptions['floatingFilter'] = (typeof this.gridOptions['floatingFilter'] === "undefined") ? true : this.gridOptions['floatingFilter'];
        this.gridOptions['groupHeaderHeight'] = this.headerHeight;
        this.gridOptions['pivotGroupHeaderHeight'] = this.headerHeight;
        this.gridOptions['pivotHeaderHeight'] = this.headerHeight;
        this.gridOptions['headerHeight'] = this.headerHeight;
        this.gridOptions['floatingFiltersHeight'] = this.headerHeight;
        this.gridOptions['rowHeight'] = (typeof this.gridOptions['rowHeight'] === "undefined") ? this.rowHeight : this.gridOptions['rowHeight'];
        this.gridOptions['singleClickEdit'] = true;
        this.gridOptions['suppressRowClickSelection'] = this.suppressRowClickSelection;
        this.gridOptions['rowSelection'] = this.rowSelection;
        this.gridOptions['enableBrowserTooltips'] = true;
        this.gridOptions['postProcessPopup'] = (params: any) => { this.postProcessPopup(params); };
        if(this.gridOptions['rowModelType'] && this.gridOptions['rowModelType'] != "clientSide") {
            this.gridOptions['cacheBlockSize'] = 50;
        }
        this.gridOptions['rowClassRules'] = (typeof this.gridOptions['rowClassRules'] === "undefined") ? { 'modifiedRow': this.isEditedRow() } : this.gridOptions['rowClassRules'];
        this.gridOptions['enableRangeSelection'] = true;
        // this.gridOptions['suppressMultiRangeSelection'] = true;
        this.gridOptions['enableRangeHandle'] = false;
        this.gridOptions['suppressDragLeaveHidesColumns'] = true;
        if (!this.gridOptions.overlayNoRowsTemplate) {
            this.gridOptions['overlayNoRowsTemplate'] = "No records found";
        }
        this.gridOptions['sortingOrder'] = ["asc", "desc"];
        this.updateFrameworkComponents();

        if (this.showSideBar) {
            this.updateSideBarlDefault();
        }

        if (this.loadingOverlayComponent) {
            this.gridOptions['loadingOverlayComponent'] = this.loadingOverlayComponent;
        }
        if (this.noRowsOverlayComponent) {
            this.gridOptions['noRowsOverlayComponent'] = this.noRowsOverlayComponent;
        }

        if (this.gridOptions.context && this.gridOptions.context.totalGrid) {
            this.gridOptions['groupHeaderHeight'] = 0;
            this.gridOptions['pivotGroupHeaderHeight'] = 0;
            this.gridOptions['pivotHeaderHeight'] = 0;
            this.gridOptions['headerHeight'] = 0;
            this.gridOptions['floatingFiltersHeight'] = 0;
            this.headerHeight = 0;
        }

        this.gridOptions.processCellForClipboard = (typeof this.gridOptions.processCellForClipboard === "undefined") ? this.processCellForClipboard.bind(this) : this.gridOptions.processCellForClipboard;
    }
    updateSideBarlDefault() {
        if (!this.sideBar) {
            this.sideBar = { 'toolPanels': [] };
        }
        this.sideBar.toolPanels.push({
            id: 'columns',
            labelDefault: 'COLUMNS',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressSideButtons: true,
                suppressColumnFilter: true,
                suppressColumnSelectAll: true,
                suppressColumnExpandAll: true
            }
        });
        this.checkIfFilterPanelExists(this.sideBar);
    }

    updateFrameworkComponents() {
        if (!this.frameworkComponents) {
            this.frameworkComponents = {};
        }
        this.frameworkComponents['customHeader'] = IrbCustomHeaderComponent;
        this.frameworkComponents['cellRendererFormatter'] = PortColFormatterComponent;
        this.frameworkComponents['irbAgNumberColumnFilterComponent'] = IrbAgNumberColumnFilterComponent;
        this.frameworkComponents['irbAgSearchMultipleColumnFilterComponent'] = IrbAgSearchMultipleColumnFilterComponent;
        this.frameworkComponents['customLoadingOverlay'] = CustomOverlayComponent;
        this.frameworkComponents['DropdownFilterEditorComponent'] = DropdownFilterEditorComponent;
        this.frameworkComponents['IrbAgSetColumnFilterComponent'] = IrbAgSetColumnFilterComponent;
        this.frameworkComponents['rangeDatePicker'] = IrbAgDateColumnFilterComponent;
        this.frameworkComponents['agColumnHeader'] = IrbDefaultHeaderComponent;
        this.frameworkComponents['ModelReadCellComponent'] = ModelReadCellComponent;
        this.frameworkComponents['colorCategoryComponent'] = ColorCategoryComponent;
        this.frameworkComponents['NumericEditorComponent'] = NumericEditorComponent;
        this.frameworkComponents['customHeaderGroup'] = IrbHeaderGroupComponent;
        this.frameworkComponents['IrbAgSingleSelectColumnFilterComponent'] = IrbAgSingleSelectColumnFilterComponent;
        this.frameworkComponents['customNoRowOverlay'] = CustomNoRowOverlayComponent;
        this.frameworkComponents['irbInputFloatingFilterComponent'] = IrbInputFloatingFilterComponent;
    }

    headerHeightGetter() {
        let columnHeaderTexts: any = document.querySelectorAll('.ag-header-cell-text');
        columnHeaderTexts = [...columnHeaderTexts];
        const clientHeights = columnHeaderTexts.map(
            (headerText: any) => headerText.clientHeight
        );
        const tallestHeaderTextHeight = Math.max(...clientHeights);

        return tallestHeaderTextHeight;
    }
    setGridHeaderHeight() {
        if (this.gridOptions.context && this.gridOptions.context.adjustableHeadserHeight) {
            const headerHeight = this.headerHeightGetter() + 7;
            this.gridApi.setHeaderHeight(headerHeight);
        }
    }

    sizeColumnstoFitCall(_event: any) {
        if(_event.type == 'toolPanelVisibleChanged') {
            if(!_event.visible) {
                //this.sizeColumnsToFit();
            }
        } else {
            this.sizeColumnsToFit();//this.gridApi?.sizeColumnsToFit();
            this.saveStateForUser();
        }       
        
        //this.saveStateForUser();
    }

    displayedColumnstoFitCall(_params: any) {
        if (!this.colState && (!this.isGridLoaded && !(this.gridOptions.context && this.gridOptions.context.adjustableHeadserHeight))) {
            this.sizeColumnsToFit();//_params.api.sizeColumnsToFit();
            this.saveStateForUser();
            this.setGridHeaderHeight();
        }
    }

    setIcons() {
        this.icons = {
            filter: '<img height="11px" width="14px" src="../../assets/images/filter.svg" title="filter" />'
        };
        // this.icons = {
        //     filter: '<img height="11px" width="14px" src="../../assets/images/filter.svg" title="filter" />',
        //     checkboxChecked: '<img height="17px" width="17px" src="../../assets/images/checkboxChecked.svg" />',
        //     checkboxUnchecked: '<img height="17px" width="17px" src="../../assets/images/checkboxUnchecked.svg" />',
        //     checkboxIndeterminate: '<img height="17px" width="17px" src="../../assets/images/checkboxIndeterminate.svg" />',
        //     checkboxCheckedReadOnly: '<img height="17px" width="17px" src="../../assets/images/checkboxCheckedReadOnly.svg" />',
        //     checkboxUncheckedReadOnly: '<img height="17px" width="17px" src="../../assets/images/checkboxUncheckedReadOnly.svg" />',
        //     checkboxIndeterminateReadOnly: '<img height="17px" width="17px" src="../../assets/images/checkboxIndeterminate.svg" />'
        // };
    }

    hidePopupApplyFilter() {
        this.deSelectedIds = [];
        this.gridApi.hidePopupMenu();
        // this.gridApi.onFilterChanged(); // TODO: due to this line filter call firing
    }

    postProcessPopup(params: any) {
        setTimeout(() => {

            this.filterParams = params;
            const isExcelMode = this.filterParams &&
              this.filterParams.column && this.filterParams.column.colDef &&
              this.filterParams.column.colDef.filterParams && this.filterParams.column.colDef.filterParams.excelMode === 'windows';
            if (isExcelMode) {
                const miniFilterInput = params.ePopup.querySelector('input[ref="eInput"].ag-input-field-input.ag-text-field-input');
                if (miniFilterInput) {
                    miniFilterInput.removeEventListener('keyup', this.miniFilterInputKeyUp);
                    miniFilterInput.addEventListener('keyup', this.miniFilterInputKeyUp);
                    if (this.filterParams && this.filterParams.column && this.filterParams.column.colDef && this.filterParams.column.colDef.field) {
                        this.gridApi.getColumnFilterInstance(this.filterParams.column.colDef.field).then((f:any) => {
                            f.setMiniFilter(this.minifilters.get(this.filterParams.column.colDef.field) || '');
                        });
                    }
                    const resetButton: any = params.ePopup.querySelector('button.ag-filter-apply-panel-button[ref="resetFilterButton"]');
                    if (resetButton) {
                        resetButton.removeEventListener('click', this.resetButtonClick);
                        resetButton.addEventListener('click', this.resetButtonClick);
                    }
                }
            } else {
                if (this.filterParams && this.filterParams.column && this.filterParams.column.colDef && this.filterParams.column.colDef.field) {
                    this.gridApi.getColumnFilterInstance(this.filterParams.column.colDef.field).then((f:any) => {
                        if (f && typeof f.setMiniFilter === 'function') { f.setMiniFilter(''); }
                    });
                }
            }
            const checkRichSelect = params.ePopup.firstChild;
            if (checkRichSelect?.className === 'ag-rich-select') {
                const richSelect = params.ePopup.querySelector('div.ag-rich-select');
                const list = params.ePopup.querySelector('div.ag-rich-select-list > div > div').children;
                params.ePopup.style.top = params.ePopup.offsetTop + 31 + 'px';
            }
        }, 0);
    }

    getFilter(colId: string): any {
        return this.gridApi.getColumnFilterModel(colId);
    }

    setFilter(colId: string, value: any) {
        /*this.gridApi.getColumnFilterInstance(colId).then((f:any) => {
            f.setModel(value);
            this.hidePopupApplyFilter();
        });*/
        this.gridApi.setColumnFilterModel(colId, value);
        this.hidePopupApplyFilter();
    }

    clearFilter(colId: string) {
        this.gridApi.getColumnFilterInstance(colId).then((f:any) => {
            f.setModel(null);
            this.hidePopupApplyFilter();
        });
    }

    miniFilterInputKeyUp = (event: any) => {
        if (event && event.target) {
            const value = event.target.value || '';
            if (this.filterParams && this.filterParams.column && this.filterParams.column.colDef && this.filterParams.column.colDef.field) {
                this.minifilters.set(this.filterParams.column.colDef.field, value);
            }
        }
    };

    resetButtonClick = () => {
        if (this.filterParams && this.filterParams.column && this.filterParams.column.colDef && this.filterParams.column.colDef.field) {
            this.minifilters.set(this.filterParams.column.colDef.field, '');
        }
    };

    private isEditedRow() {
        return (params: any) => {
            if (params.data) {
                return params.data.edited;
            }
        };
    }
    
    getSavedState(){
        if (this.componentName != null && localStorage.getItem(this.componentName) != null) {
            this.savedState = JSON.parse(localStorage.getItem(this.componentName));
            this.colState = JSON.parse(this.savedState.COL_STATE);
            this.sortState = JSON.parse(this.savedState.SORT_STATE);
            if(this.savedState && this.savedState.SCREEN_RESOLUTION) {
                this.screenResolutionState = this.savedState.SCREEN_RESOLUTION;
            } else {
                this.screenResolutionState = this.getCurrentScreenResolution();
            }
        }
    }

    resetSavedState(params: any) {
        if (this.savedState) {
            const colState = this.colState;
            let sortState = this.sortState;

            if (this.saveSortState && sortState?.length > 0) {
                if (sortState[0] === null) {
                    sortState[0] = {colId:null};
                }
                
                this.gridApi.applyColumnState({state: sortState});
            } 
            
            if(this.onResetSavedState.observers?.length > 0){
                this.onResetSavedState.emit({
                    colState: colState,
                    params: params
                });
            } else {
                colState.forEach(function (item: any, index: number) {
                    params.api.setColumnsVisible([item.colId], !item.hide);
                    setTimeout(()=> {
                        if (params && params.api && params.api.moveColumns)
                            params.api.moveColumns([item.colId], index);
                    }, 10);
                });
            }
        }
    }

    getCurrentScreenResolution() {
        return screen.width + "x" + screen.height;
    }

    resetSavedColumnSize(params: any) {
        if(!this.savedState && !this.colState) {
            this.getSavedState();
        }

        if(this.savedState && this.colState) {
            const colState = this.colState;
            if(colState) {
                let currentScreenResolution = this.getCurrentScreenResolution();
                if(currentScreenResolution === this.screenResolutionState) {
                    colState.forEach(function (item: any) {
                            params.api.setColumnWidths([{key: item.colId, newWidth: item.width}]);
                        }
                    );
                } else {
                    this.sizeColumnsToFit();//params.api.sizeColumnsToFit();
                }
            }
            this.colState.forEach((item: any) => {
                params.api.setColumnWidths([{key: item.colId, newWidth: item.width}]);
            });
        } else {
            if (!(this.gridOptions.context && this.gridOptions.context.adjustableHeadserHeight)) {
                this.sizeColumnsToFit();//params.api.sizeColumnsToFit();
            }
        }
    }

    sizeColumnsToFit() {
        // columnLimits - are define initial autoSizeStrategy
        // if exists grid will load with these limits (minWidth) on intial load or reset.
        // But it's not overwrite column definitions minWidth, so user can resize columns after that.
        if (this.columnLimits)
            this.gridApi?.sizeColumnsToFit(this.columnLimits);
        else
            this.gridApi?.sizeColumnsToFit();

        let lastColumn = null;
        let cs = this.gridApi?.getColumnState();

        for(let i = cs?.length - 1; i >= 0; i--) {
            if(cs[i].hide === false) {
                lastColumn = (cs) ? cs[i] : null;
                break;
            }
        }

        if(lastColumn) {
            this.gridApi?.setColumnWidths([{key: lastColumn?.colId, newWidth: lastColumn?.width - 2}]);
        }
    }

    saveStateForUser() {
        if (this.gridApi != null && this.gridColumnApi != null && this.componentName != null && this.isGridLoaded) {
            let cs = this.gridColumnApi.getColumnState();
            let autoColumnIndex = cs.findIndex((x: any) => x.colId === "ag-Grid-AutoColumn");
            let syncColumnIndex = cs.findIndex((x: any) => x.colId === this.autoColumnId);

            if(autoColumnIndex != -1 && syncColumnIndex != -1) {
                cs[syncColumnIndex].width = cs[autoColumnIndex].width;
            } else if(syncColumnIndex != -1) {
                let a = JSON.parse(JSON.stringify(cs[syncColumnIndex]));
                a.colId = "ag-Grid-AutoColumn";
                cs.push(a);
            }

            let columnWithSort = this.gridApi.getColumnState().filter((col:any) => col.sort !== null);
            const sortMdl: any = (columnWithSort.length > 0) ? columnWithSort : (this.sortState) ? this.sortState : [];
            const stateValue = {
                'COL_STATE': JSON.stringify(cs),
                'COL_GROUP_STATE': JSON.stringify(this.gridColumnApi.getColumnGroupState()),
                'SORT_STATE': JSON.stringify(sortMdl),//JSON.stringify(this.gridApi.getSortModel()),
                'SCREEN_RESOLUTION':screen.width + "x" + screen.height
            };

            localStorage.setItem(this.componentName, JSON.stringify(stateValue));
            this.applyToolbarColumnResetButton();
            if (this.gridOptions.context && this.gridOptions.context.componentParent && this.gridOptions.context.componentParent.saveGridColumnPreference)
                this.gridOptions.context.componentParent.saveGridColumnPreference(stateValue);
        }
    }

    applyToolbarColumnResetButton() {
        let elem: any = document;
        if (this.gridOptions.context && this.gridOptions.context.parentId) {
            elem = document.getElementById(this.gridOptions.context.parentId);
            if (!elem) {
                elem = document;
            }
        }
        const toolBarColumnElements = elem.querySelectorAll('.ag-column-select');
        const checkResetButton = elem.querySelectorAll('.ag-primary-cols-reset-header-panel');
        const toolBarFilterElements = elem.querySelectorAll('.ag-filter-toolpanel');
        const checkClearAllButton = elem.querySelectorAll('.ag-primary-filter-reset-header-panel');
        if (toolBarColumnElements.length && this.showSideBar && (checkResetButton.length === 0 ||
            (checkResetButton.length === 1 && this.gridOptions.context && this.gridOptions.context.parentId === 'irb-allocation-details-component'))) {
            const columnResetButtonDom = this.createCustomDom('ag-primary-cols-reset-header-panel', 'resetIcon', 'Reset columns', 'resetText');
            toolBarColumnElements[0].appendChild(columnResetButtonDom);
            columnResetButtonDom.addEventListener('click', () => {
                this.columnResetAction();
                this.as.fireEvent(IrbAppEvents.GRID_COLUMN_RESET);
            });
        }
        if (toolBarFilterElements.length && this.showSideBar && checkClearAllButton.length === 0) {
            const filterResetButtonDom = this.createCustomDom('ag-primary-filter-reset-header-panel', 'btn-action-clear-filter-sidebar', 'Clear all filters', 'resetText');
            toolBarFilterElements[0].appendChild(filterResetButtonDom);
            filterResetButtonDom.addEventListener('click', () => this.as.fireEvent(IrbAppEvents.GRID_FILTER_RESET));
        }
    }

    createCustomElement(textContent: string, className: string) {
        const customEle = document.createElement('div');
        if (textContent) {
            customEle.textContent = textContent;
        }
        customEle.className = className;
        return customEle;
    }

    createCustomDom(layoutClassName: string, iconClassName: string, btnName: string, btnClass: string) {
        const columnResetButton = document.createElement('div');
        columnResetButton.className = layoutClassName;
        columnResetButton.appendChild(this.createCustomElement(null, iconClassName));
        columnResetButton.appendChild(this.createCustomElement(btnName, btnClass));
        return columnResetButton;
    }

    columnResetAction() {
        localStorage.removeItem(this.componentName);
        this.gridApi.resetColumnState();
        this.gridApi.resetColumnGroupState();
        if (!this.columnLimits)
            this.gridApi.applyColumnState({state: this.defaultColumnStateOnPageLoad.getColumnState });
        this.sizeColumnsToFit();//this.gridApi.sizeColumnsToFit();
        this.onColumnVisible(null);
    }

    getContextMenuItems():Array<MenuItemDef> {
        let gridCntxMnu: Array<any> =  ['copy', 'separator', 'copyWithHeaders'];
        if (this.contextMenuItems && Array.isArray(this.contextMenuItems) && this.contextMenuItems.length !== 0) {
            gridCntxMnu.push('separator');
            gridCntxMnu = gridCntxMnu.concat(this.contextMenuItems);
        }
        //autosize columns
        //let autoSizeAllColumn = ['separator', 'autoSizeAll'];
        let autoSizeAllColumn = [
            'separator',
            {
                name:"Autosize All Columns",
                action:() => {
                    this.gridColumnApi.autoSizeAllColumns();
                    this.saveStateForUser();
                }
            }];

        gridCntxMnu = gridCntxMnu.concat(autoSizeAllColumn);
        // 'Reset columns'
        let resetColumnItem =  ['separator',
            {
                name: "Reset columns",
                action: this.resetColumnsInContext.bind(this)
            }
        ];
        gridCntxMnu = gridCntxMnu.concat(resetColumnItem);
        return gridCntxMnu; // this.contextMenuItems;
    }

    resetColumnsInContext() {
        this.columnResetAction();
        this.as.fireEvent(IrbAppEvents.GRID_COLUMN_RESET);
    }

    @HostListener("window:resize", ["$event"])
    onResize() {
        setTimeout(() => {
            if(this.gridApi) {
                this.sizeColumnsToFit();//this.gridApi.sizeColumnsToFit();
                this.saveStateForUser();
            }
        });
    }

    processCellForClipboard(params: ProcessCellForExportParams): any {
        const colDef: any = params.column.getColDef();

        if(colDef?.cellRenderer === "cellRendererFormatter") {
            if (colDef.cellRendererParams?.type) {
                if(colDef.cellRendererParams.type === 'date' && params.value && colDef.cellRendererParams.format) {
                    if (colDef.cellRendererParams.displayETtext) {
                        if (typeof params.value !== "number") {
                            params.value = params.value.replace(" ET", "");
                            params.value = (new Date(params.value)).getTime();
                        }

                        return this.dp.transform(this.etp.transform(params.value), colDef.cellRendererParams.format) + ' ET';
                    } else {
                        return this.dp.transform(params.value, colDef.cellRendererParams.format);
                    }
                }
            }
        } else if(colDef?.cellRenderer === "DropdownSearchMultipleRendererComponent") {
            const labels = params.value?.map((x: any) => {
                if(x.name) {
                    return x.name
                } else if(x.label && x.allocation) {
                    return x.label + "|" + x.allocation + "%";
                } else {
                    return "";
                }
            }) || [];

            return labels.join("^");
        }

        return params.value;
    }

    onColumnResized(ev: any) {
        if (ev.source === 'uiColumnResized') {
            if (ev.finished)
                this.saveStateForUser();
        }
    }

    onColumnVisible(ev: any) {        
        if (this.gridOptions && this.gridOptions.context && this.gridOptions.context.componentParent && this.gridOptions.context.componentParent.addRemoveFilterToPanel) {
            let allColumns: any;
            if (ev === null) {
                allColumns = this.gridColumnApi?.getColumns() || [];

                if (allColumns.length !== 0) {
                    for (const col of allColumns) {
                       ev = {column: {colDef: col.colDef}};
                       break;
                    }
                } else {
                    return;
                }
            }
            if (ev.column && ev.column.colDef) {

                let customToolPanelColumnDefs = this.gridOptions.context.componentParent.addRemoveFilterToPanel();

                const cols: any = allColumns || ev.api.getColumns();
                let findCol: any;
                let panelFilters;
                if (cols && cols.length !== 0) {
                    cols.forEach((col: any) => {
                        if (!col.visible) {
                            panelFilters = customToolPanelColumnDefs[0].children ? customToolPanelColumnDefs[0].children : customToolPanelColumnDefs;
                            findCol = panelFilters.filter((c: any) => c.field === col.colId);
                            if (findCol && findCol.length === 0 && col.colDef.filter && col.colDef.field  !== 'quickfilter') {
                                col.colDef.suppressFiltersToolPanel = false;
                                panelFilters.push({field: col.colId});
                            }
                        }
                    });
                }

                panelFilters = customToolPanelColumnDefs[0].children ? customToolPanelColumnDefs[0].children : customToolPanelColumnDefs;
                let toolPanels = this.gridApi.getSideBar().toolPanels;
                if (panelFilters && panelFilters.length !== 0) {
                    const isFilters = toolPanels.filter((f:any) => f.id === 'filters');
                    if (isFilters && isFilters.length === 0) {
                        const fltrTP = {
                            id: 'filters',
                            labelDefault: 'FILTERS',
                            labelKey: 'filters',
                            iconKey: 'filter',
                            toolPanel: 'agFiltersToolPanel',
                            toolPanelParams: {
                                suppressExpandAll: true,
                                suppressFilterSearch: true,
                                suppressSyncLayoutWithGrid: true,
                            },
                        };
                        const newSideBar = this.sideBar ? JSON.parse(JSON.stringify(this.sideBar)) : { 'toolPanels': [] };
                        newSideBar.toolPanels.unshift(fltrTP);
                        if (this.gridApi.getOpenedToolPanel() === 'columns')
                            newSideBar.defaultToolPanel = 'columns';

                        this.gridApi.setGridOption("sideBar", newSideBar);
                        this.applyToolbarColumnResetButton();
                    }
                    
                    const filtersToolPanel = this.gridApi.getToolPanelInstance('filters');

                    if (filtersToolPanel) {
                        filtersToolPanel.setFilterLayout(customToolPanelColumnDefs);
                        this.filterToolPanelExists = true;

                        if (this.gridOptions.context.componentParent.listOfExpandFilters) {
                            filtersToolPanel.expandFilters(this.gridOptions.context.componentParent.listOfExpandFilters());
                        }
                    } else
                        this.filterToolPanelExists = false;
                } else {
                    const sideBar1 = this.sideBar || { 'toolPanels': [] };
                    if (this.gridApi.getOpenedToolPanel() === 'columns')
                        sideBar1.defaultToolPanel = 'columns';

                    this.checkIfFilterPanelExists(sideBar1);
                    this.gridApi.setGridOption("sideBar", sideBar1);
                    this.applyToolbarColumnResetButton();
                }

                const filterPanel = this.as.getItem(this.componentName + '_FilterPanel');
                const openedToolPanel = this.gridApi.getOpenedToolPanel();
                if (filterPanel === true) {
                  this.gridApi.setSideBarVisible(true);
                  this.gridApi.openToolPanel('filters');
                  if (openedToolPanel === 'columns') {
                    this.gridApi.openToolPanel('columns');
                  }
                }
            }
        }

        if (ev?.source === "toolPanelUi" && !this.showFiltersColumns) {
            this.sizeColumnsToFit();
        }

        this.columnVisible.emit(ev);
    }

    onRowSelected(_e: any) {
        setTimeout(() => {
            if(this.gridOptions.context?.componentParent.isSelectedAll) {
                this.selectedIds = [];
                if(this.gridOptions.context?.componentParent.uniqueField) {
                  const id = _e.data[this.gridOptions.context.componentParent.uniqueField];
                  this.deSelectedIds = this.deSelectedIds.filter((x: any) => x !== id);
                  if(!_e.node.isSelected()) {
                      this.deSelectedIds.push(id);
                  }
                }
            } else {
                this.deSelectedIds = [];
                if(this.gridOptions.context?.componentParent.uniqueField) {
                    const id = _e.data[this.gridOptions.context.componentParent.uniqueField];
                    this.selectedIds = this.selectedIds.filter((x: any) => x !== id);

                    if(_e.node.isSelected()) {
                        this.selectedIds.push(id);
                    }
                }
            }
        });
    }

    restoreSelection() {
        setTimeout(() => {
            if(this.gridOptions.context?.componentParent.uniqueField) {
              if (this.gridOptions.context?.componentParent.isSelectedAll) {
                //const deSelectedIds = this.gridOptions.context.componentParent.deselectedFromSelectAllRecords;
                this.gridApi.forEachNode((node: any) => {
                  if(node.data) {
                    if (this.deSelectedIds.includes(node.data[this.gridOptions.context.componentParent.uniqueField])) {
                      node.setSelected(false);
                    }
                  }
                });
              } else {
                this.deSelectedIds = [];
                this.gridApi.forEachNode((node: any) => {
                    if(node.data) {
                        node.setSelected(this.selectedIds.includes(node.data[this.gridOptions.context.componentParent.uniqueField]));
                    }
                });
                  // set selectedRowsMap for selected nodes
                  const selectedRows: any = this.gridApi.getSelectedRows();
                  if (selectedRows.length && this.gridOptions.context.componentParent.selectedRowsMap) {
                      selectedRows.forEach((rowData: any) => {
                          this.gridOptions.context.componentParent.selectedRowsMap.set(rowData[this.gridOptions.context.componentParent.uniqueField], rowData);
                      });
                  }

                this.gridOptions.context.componentParent.enableDisableBtns();
              }
            }
        });
    }

    showGridFiltersToolBar() {
        let filterPanelKey = this.componentName + '_FilterPanel';
        if (this.gridApi.getOpenedToolPanel() === 'filters') {
            this.gridApi.setSideBarVisible(false);
            this.gridApi.closeToolPanel();
            this.as.setItem(filterPanelKey, false);
            return;
        }

        this.gridApi.setSideBarVisible(true);
        this.gridApi.openToolPanel('filters');
        this.as.setItem(filterPanelKey, true);
    }

    showGridColumnsToolBar() {
        if (this.gridApi.getOpenedToolPanel() === 'columns') {
            this.gridApi.setSideBarVisible(false);
            this.gridApi.closeToolPanel();
            return;
        }
        this.gridApi.setSideBarVisible(true);
        this.gridApi.openToolPanel('columns');
    }

    checkIfFilterPanelExists(newSideBar: any) {
        let filterPanelExists = false;
        newSideBar.toolPanels.forEach((panel: any) => {
            if (panel.id === 'filters') {
                filterPanelExists = true;
            }
        });
        this.filterToolPanelExists = filterPanelExists;
    }
}
